import { useModalStore } from "@shared/components/Modal/stores/Modal.store";
import { IModal } from "@shared/components/Modal/interfaces/IModal";

const useModal = () => {
  const modals = useModalStore((state) => state.modals);
  const setModals = useModalStore((state) => state.setModals);

  const open = (modal: IModal, options?: any) => {
    setModals(!!options?.isStandaloneModal ? [modal] : [...modals, modal]);
  };

  const close = (data?: any) => {
    const lastModal = modals[modals.length - 1];
    if (lastModal?.onHide) {
      lastModal.onHide(data);
    }

    setModals(modals.slice(0, -1));
  };

  return {
    open,
    close
  };
};

export default useModal;
